import { $translate } from '@/utils/i18n';
export const searchListConfig = {
    searchList: [
        {
            type: 'input',
            value: 'creationBy',
            label: $translate('lang.E3202102220015', { defaultText: '上传人' }),
            placeholder: $translate('lang.E3202102220015', { defaultText: '上传人' }),
            ref: 'uploadPerson'
        },
        {
            type: 'date',
            value: 'uploadTime',
            label: $translate('lang.E3202102220016', { defaultText: '上传日期' }),
            placeholder: $translate('lang.E3202102220016', { defaultText: '上传日期' })
        },
        {
            type: 'select',
            value: 'runFlag',
            label: $translate('lang.E3202102220017', { defaultText: '是否校验' }),
            placeholder: $translate('lang.E3202102220017', { defaultText: '是否校验' }),
            clearable: true,
            options: [{
                label: $translate('lang.E3202102230001', { defaultText: '是' }),
                value: 'Y'
            }, {
                label: $translate('lang.E3202102230002', { defaultText: '否' }),
                value: 'N'
            }]
        },
        {
            type: 'select',
            value: 'barCheckInvaildCode',
            label: $translate('lang.E3202102220018', { defaultText: '条码是否正确' }),
            placeholder: $translate('lang.E3202102220018', { defaultText: '条码是否正确' }),
            clearable: true,
            options: [{
                label: $translate('lang.E3202102230001', { defaultText: '是' }),
                value: 'Y'
            }, {
                label: $translate('lang.E3202102230002', { defaultText: '否' }),
                value: 'N'
            }]
        },
        {
            type: 'select',
            value: 'reuploadFlag',
            label: $translate('lang.E3202102220019', { defaultText: '是否重复上传' }),
            placeholder: $translate('lang.E3202102220019', { defaultText: '是否重复上传' }),
            clearable: true,
            options: [{
                label: $translate('lang.E3202102230001', { defaultText: '是' }),
                value: 'Y'
            }, {
                label: $translate('lang.E3202102230002', { defaultText: '否' }),
                value: 'N'
            }]
        },
        {
            type: 'input',
            value: 'salescenterCode',
            label: $translate('lang.E3202102220020', { defaultText: '所属中心编码' }),
            placeholder: $translate('lang.E3202102220020', { defaultText: '所属中心编码' })
        },
        {
            type: 'input',
            value: 'parCustomerCode',
            label: $translate('lang.E3202102220021', { defaultText: '上级客户编码' }),
            placeholder: $translate('lang.E3202102220021', { defaultText: '上级客户编码' })
        },
        {
            type: 'input',
            value: 'batchId',
            label: $translate('lang.E3202102220022', { defaultText: '批次号' }),
            placeholder: $translate('lang.E3202102220022', { defaultText: '批次号' })
        },
        {
            type: 'select',
            value: 'activeFlag',
            label: $translate('lang.E3202102220023', { defaultText: '有效标志' }),
            placeholder: $translate('lang.E3202102220023', { defaultText: '有效标志' }),
            clearable: true,
            options: [{
                label: $translate('lang.E3202102230001', { defaultText: '是' }),
                value: 'Y'
            }, {
                label: $translate('lang.E3202102230002', { defaultText: '否' }),
                value: 'N'
            }]
        },
        {
            type: 'input',
            value: 'remark',
            label: $translate('lang.E3202102220024', { defaultText: '备注' }),
            placeholder: $translate('lang.E3202102220024', { defaultText: '备注' })
        }
    ]
};
